/** Shared Emotion/MUI styles for marketing homepage SSR (replaces CSS modules). */

export const homePageLayoutSx = {
  display: 'flex',
  flexDirection: 'column',
  flex: '1 0 auto',
};

export const homeAnchorSx = {
  position: 'relative',
  top: -80,
  visibility: 'hidden',
  height: 0,
  width: 0,
};

export const marketingContainerSx = {
  width: '100%',
  maxWidth: { xs: '100%', sm: 750, md: 970, lg: 1170 },
  mx: 'auto',
  px: 2,
  boxSizing: 'border-box',
};

export const marketingTitleSx = {
  fontWeight: 800,
  letterSpacing: 0,
  color: 'rgba(0, 0, 0, 0.8)',
};

export const marketingBtnPrimarySx = {
  display: 'inline-block',
  fontSize: { xs: 13, md: 14 },
  lineHeight: '20px',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  py: { xs: '13px', md: '11px' },
  px: { xs: '30px', md: '28px' },
  border: '1px solid #33cc99',
  borderRadius: '30px',
  bgcolor: '#33cc99',
  color: '#fff',
  cursor: 'pointer',
  textDecoration: 'none',
  '&:hover': {
    bgcolor: '#111',
    borderColor: '#111',
    color: '#fff',
  },
};

export const marketingFormGroupSx = {
  mb: 2,
};

export const marketingFormControlSx = {
  display: 'block',
  width: '100%',
  height: 40,
  px: 1.5,
  fontSize: 16,
  lineHeight: 1.5,
  color: '#333',
  bgcolor: '#fff',
  border: '1px solid #ccc',
  borderRadius: 1,
  boxSizing: 'border-box',
  fontFamily: '"Figtree", sans-serif',
  '&:focus': {
    outline: 0,
    borderColor: '#66afe9',
    boxShadow: 'inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6)',
  },
};

export const marketingPanelSx = {
  bgcolor: '#fff',
  border: '1px solid #ddd',
  borderRadius: 1,
  boxShadow: '0 1px 1px rgba(0,0,0,.05)',
  mb: 2,
};

export const marketingPanelBodySx = {
  p: 2,
  textAlign: 'center',
};

export const homeInputErrorSx = {
  color: '#fdc1c1',
  display: 'block',
  bgcolor: '#ed1b25',
  borderRadius: 1,
  border: '1px solid #760f14',
  fontSize: 14,
  py: 0.5,
  px: 1.5,
  mt: 0.5,
};

export const navbarSx = inverse => ({
  position: 'fixed',
  minHeight: 80,
  border: 'none',
  p: 0,
  left: 0,
  right: 0,
  top: 0,
  transition: 'all .5s ease',
  zIndex: 1030,
  bgcolor: inverse ? '#fff' : 'transparent',
  boxShadow: inverse ? '0 1px 0 rgba(0, 0, 0, 0.08)' : 'none',
});

export const navContainerSx = {
  position: 'relative',
  zIndex: 77,
  maxHeight: 80,
  ...marketingContainerSx,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const navBrandSx = {
  position: 'relative',
  width: 180,
  minHeight: 80,
  display: 'flex',
  alignItems: 'center',
  ml: { lg: -2 },
  '& a': { textDecoration: 'none', display: 'block', position: 'relative', width: 180, height: 50 },
};

export const navLogoSx = inverse => ({
  lineHeight: 0,
  position: 'absolute',
  top: '50%',
  left: 0,
  transform: 'translateY(-50%)',
  width: 180,
  opacity: inverse ? 1 : 0,
  '& svg': { width: 180, maxHeight: 68 },
});

export const navLogoReverseSx = inverse => ({
  lineHeight: 0,
  position: 'absolute',
  top: '50%',
  left: 0,
  transform: 'translateY(-50%)',
  width: 180,
  opacity: inverse ? 0 : 1,
  '& svg': { width: 180, maxHeight: 68 },
});

export const navListSx = inverse => ({
  lineHeight: 'normal',
  p: 0,
  m: 0,
  ml: 1.25,
  listStyle: 'none',
  flex: '1 1 auto',
  alignItems: 'center',
  justifyContent: 'flex-end',
  '& > li': {
    m: 0,
    p: 0,
    listStyle: 'none',
    display: 'flex',
    alignItems: 'center',
  },
  '& > li > a': {
    ml: '5px',
    fontSize: '1em',
    color: inverse ? '#33cc99' : '#fff',
    display: 'inline-block',
    lineHeight: 1.6,
    textTransform: 'uppercase',
    py: '5px',
    px: '15px',
    borderRadius: '25px',
    letterSpacing: '1px',
    textDecoration: 'none',
    transition: '.4s',
    fontFamily: '"Figtree", sans-serif',
    fontWeight: 400,
    whiteSpace: 'nowrap',
  },
  '& > li.is-current > a': {
    fontWeight: 800,
    color: inverse ? '#000' : '#fff',
  },
  '& > li > a.cta': {
    bgcolor: '#203161',
    border: '1px solid transparent',
    color: '#fff',
    fontSize: 12,
    fontWeight: 800,
  },
});

export const navMobileMenuOpenSx = {
  '@media (max-width: 991px)': {
    position: 'absolute',
    bgcolor: '#fff',
    top: 80,
    width: '100%',
    maxWidth: 500,
    right: 0,
    py: 2,
    px: 2,
    flex: 'none',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
    borderBottomLeftRadius: 8,
    '& > li': {
      display: 'block',
      width: '100%',
      mb: 0.5,
      '&:last-child': { mb: 0 },
    },
    '& > li > a': {
      color: '#33cc99',
      display: 'block',
      ml: 0,
      py: '14px',
      px: '20px',
      borderRadius: '8px',
      '&:hover': {
        bgcolor: 'rgba(51, 204, 153, 0.08)',
      },
    },
    '& > li.is-current > a': {
      color: '#000',
      fontWeight: 800,
    },
    '& > li > a.cta': {
      color: '#fff',
      bgcolor: '#203161',
      mt: 1.5,
      textAlign: 'center',
      '&:hover': {
        bgcolor: '#1a2750',
      },
    },
  },
};

export const navWrapperSx = {
  height: 0,
};

export const homeIntroSx = {
  position: 'relative',
  overflow: 'hidden',
  background:
    'linear-gradient(rgba(92, 192, 145, 0.9), rgba(35, 181, 195, 0.5) 20%, rgba(35, 181, 195, 0) 40%), #ffffff',
  backgroundSize: 'cover',
  pt: { xs: '150px', md: '200px' },
  pb: 0,
  boxSizing: 'border-box',
};

export const homeHeroRowSx = {
  display: { md: 'flex' },
  alignItems: { md: 'center' },
  mb: { md: '18rem' },
  px: { xs: 2, md: 0 },
};

export const homeHeroRowReverseSx = {
  display: { md: 'flex' },
  flexDirection: { md: 'row-reverse' },
  justifyContent: { md: 'space-around' },
  alignItems: { md: 'center' },
  mb: { md: '18rem' },
  px: { xs: 2, md: 0 },
};

export const homeColMd6Sx = {
  width: { xs: '100%', md: '50%' },
  boxSizing: 'border-box',
  mb: 2,
};

export const homeColMd5Sx = {
  width: { xs: '100%', md: '41.666%' },
  ml: { md: '8.333%' },
  boxSizing: 'border-box',
};

export const homeColMd7Sx = {
  width: { xs: '100%', md: '58.333%' },
  boxSizing: 'border-box',
};

export const homeColMd4Sx = {
  width: { xs: '100%', md: '33.333%' },
  boxSizing: 'border-box',
  mb: 2,
};

export const homeHeroTitleSx = {
  ...marketingTitleSx,
  fontSize: { xs: 33, md: 42 },
  lineHeight: { xs: '43px', md: 1.2 },
  mb: 3,
};

export const homeHeroTextSx = {
  fontSize: 15,
  fontWeight: 400,
  color: '#000',
  pb: 2.5,
  lineHeight: '28px',
};

export const homeFormTitleSx = {
  fontWeight: 800,
  my: 2,
};

export const homeAcceptTermsSx = {
  color: '#b3b3b3',
  fontSize: '1rem',
  mb: 0,
  '& a': {
    color: '#999',
    borderBottom: '1px dashed #999',
    textDecoration: 'none',
  },
};

export const homeSurveyTypeSx = {
  display: 'inline-block',
  width: 120,
  '& span': {
    display: 'inline-block',
    lineHeight: '0.85em',
    borderBottom: '4px solid #008000',
  },
};

export const browserWindowSx = {
  borderRadius: '6px',
  border: '1px solid #adadad',
  boxShadow: { xs: '0 5px 20px rgba(0, 0, 0, 0.55)', md: '0 20px 70px rgba(0, 0, 0, 0.55)' },
  mx: 'auto',
  overflow: 'hidden',
};

export const browserBarSx = {
  borderTopLeftRadius: '6px',
  borderTopRightRadius: '6px',
  color: '#505151',
  fontSize: 12,
  fontWeight: 'bold',
  background:
    'radial-gradient(7px at 14px 50%, #ff5e57 0px, #ff635a 5px, #fd5249 6px, rgba(255, 255, 255, 0) 7px), radial-gradient(7px at 34px 50%, #ffbd2e 0px, #ffc42f 5px, #fcb91b 6px, rgba(255, 255, 255, 0) 7px), radial-gradient(7px at 54px 50%, #62c755 0px, #65CC57 5px, #54B542 6px, rgba(255, 255, 255, 0) 7px), #ffffff',
  height: 40,
  display: 'flex',
  alignItems: 'center',
  px: 2,
};

export const browserNavigationSx = {
  width: '60%',
  bgcolor: '#fafaf9',
  ml: 2,
  height: '1.6rem',
  borderRadius: '0.5rem',
};

export const browserFrameSx = {
  display: 'block',
  bgcolor: '#fff',
  width: '100%',
};

export const featuresSectionSx = {
  boxSizing: 'border-box',
  bgcolor: '#fff',
  py: 6,
  '& h3': {
    ...marketingTitleSx,
    fontSize: { xs: 33, md: 48 },
    lineHeight: { xs: '43px', md: 1.2 },
    mb: 3,
  },
  '& p': {
    fontSize: 20,
    fontWeight: 400,
    color: 'rgba(0, 0, 0, .7)',
    opacity: 0.8,
    pb: 1.5,
  },
};

export const featuresRowSx = reverse => ({
  display: 'flex',
  flexDirection: { xs: 'column', sm: reverse ? 'row-reverse' : 'row' },
  alignItems: 'center',
  mb: 6,
});

export const featuresTextColSx = {
  width: { xs: '100%', sm: '41.666%' },
  boxSizing: 'border-box',
  px: { xs: 2, sm: 3 },
};

export const featuresImageColSx = {
  width: { xs: '100%', sm: '58.333%' },
  boxSizing: 'border-box',
  p: { xs: 0, sm: 5 },
  display: { xs: 'none', sm: 'block' },
};

export const featuresImageSx = {
  display: 'block',
  maxWidth: '100%',
  height: 'auto',
  mx: 'auto',
};

export const productSectionSx = {
  bgcolor: '#fff',
};

export const productIntroSx = {
  bgcolor: '#fff',
  py: { xs: 6, md: 12 },
  '& h3': {
    ...marketingTitleSx,
    fontSize: { xs: 36, md: 48 },
    mb: 3,
  },
  '& h4': {
    fontSize: 24,
    fontWeight: 800,
  },
  '& p': {
    fontSize: 16,
    color: 'rgba(0, 0, 0, .7)',
    opacity: 0.8,
    pb: 1.5,
  },
  '& ul': {
    color: 'rgba(0, 0, 0, .7)',
    listStyle: 'none',
    p: 0,
  },
  '& img': {
    filter: 'drop-shadow(0px 30px 35px rgba(0, 0, 0, 0.4))',
    maxWidth: '100%',
    height: 'auto',
    display: 'block',
    mx: 'auto',
  },
};

export const productRowSx = {
  display: 'flex',
  flexDirection: { xs: 'column', sm: 'row' },
  alignItems: 'center',
  ...marketingContainerSx,
};

export const productTextColSx = {
  width: { xs: '100%', sm: '41.666%' },
  boxSizing: 'border-box',
};

export const productImageColSx = {
  width: { xs: '100%', sm: '58.333%' },
  alignSelf: 'center',
  boxSizing: 'border-box',
};

export const productBtnWrapSx = {
  my: 4,
};

export const productDlSx = {
  display: 'flex',
  flexFlow: 'row wrap',
  width: 300,
  overflow: 'visible',
  '& dt': {
    flex: '0 0 25%',
    '&:before': { content: '"-"', mr: 0.5, ml: 1 },
  },
  '& dd': {
    ml: 'auto',
    flex: '0 0 70%',
    m: 0,
  },
};

export const testimonialsSectionSx = {
  bgcolor: '#fff',
  boxSizing: 'border-box',
};

export const testimonialsInnerSx = {
  py: { xs: 8, md: 17 },
  ...marketingContainerSx,
};

export const testimonialsHeadSx = {
  textTransform: 'uppercase',
  fontWeight: 700,
  mb: 2,
  fontSize: 25,
  letterSpacing: 3,
  textAlign: 'center',
};

export const testimonialsGridSx = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
  gap: 3,
};

export const testimonialCommentSx = {
  border: '1px solid #ddd',
  p: '30px 40px 70px',
  fontSize: 15,
  fontStyle: 'italic',
  color: '#777',
  m: '0 15px',
};

export const testimonialAuthorSx = {
  fontWeight: 'bold',
  fontSize: 11,
  textTransform: 'uppercase',
  letterSpacing: 1,
  color: '#111',
  display: 'block',
  textAlign: 'center',
  mt: 1,
};

export const testimonialImageSx = {
  maxWidth: 70,
  borderRadius: '50%',
  bgcolor: '#fff',
  border: '1px solid #ddd',
  p: '5px',
  mt: '-44px',
  mx: 'auto',
  display: 'block',
  boxSizing: 'content-box',
};
